import { callApi } from '@local_modules/generic/fetch'
import { createGrid, themeQuartz } from 'ag-grid-community'
import RecommendedActions from './recommended-actions.js'
import { formatNumber } from '@local_modules/flokit'

import './styles.css'

export default class BudgetGrid {
  constructor () {
    console.log('BudgetGrid constructor')

    this.htmlTemplate = `
      <wp-card class="as-full-height">
        <header>
          <h2>Budget and Actuals</h2>
        </header>
        <section class="fill-space">
          <wp-container class="as-fill-space width-full">
            <div id="for-actions">Recommended actions</div>
            <wp-container id="grid-container" class="as-fill-space width-full">Pending data...</wp-container>
          </wp-container>
        </section>
      </wp-card>
    `

    this.mountedOn = null

    this.gridApi = null
  }

  mount (element) {
    console.log('BudgetGrid mount')
    element.innerHTML = this.htmlTemplate
    this.mountedOn = element

    this.render()
  }

  /**
   *
   * @param {Object} params
   * @param {Object} params.data
   * @param {String} params.accountingOrganisationId
   * @returns
   */
  render (params = {}) {
    console.log('BudgetGrid render')
    if (!this.mountedOn) return

    this.accountingOrganisationId = params.accountingOrganisationId
    this.data = params.data

    renderGrid(this)

    this.recommendedActions = new RecommendedActions({
      budgetModule: this,
      containerId: 'for-actions'
    })
  }
}

function renderGrid (instance) {
  console.log('BudgetGrid renderGrid', instance.data)

  if (!(instance.data?.budget && instance.data?.ledgerAccounts)) {
    instance.mountedOn.querySelector('#grid-container').classList.add('is-hidden')
    return
  }

  instance.mountedOn.querySelector('#grid-container').classList.remove('is-hidden')

  const rowData = []

  const budgetData = instance.data?.budget
  if (budgetData && budgetData.parsedData && budgetData.parsedData.length > 0) {
    instance.data.budgetAccountsWithLedgerAccounts = matchBudgetToLedgerAccounts(budgetData, instance.data.ledgerAccounts, instance.data.financialStatement)
    console.log('BudgetGrid renderGrid matchedAccounts', instance.data.budgetAccountsWithLedgerAccounts)

    instance.data.budgetAccountsWithLedgerAccounts.forEach(function (oneRow) {
      if (!oneRow.budget?.totalAmount) return

      rowData.push(oneRow)
    })
  }

  if (instance.gridApi) {
    updateGrid(instance, { rows: rowData })
  } else {
    initGrid(instance, { rows: rowData })
  }
}

function matchBudgetToLedgerAccounts (budgetData, ledgerAccounts, financialStatement) {
  console.log('BudgetGrid matchBudgetToLedgerAccounts', budgetData, ledgerAccounts, financialStatement)

  // Data by chart of account+month
  const analysedFinancials = financialStatement.analysedFinancials

  const matchedData = budgetData.parsedData.map(oneRow => {
    const ledgerAccount = ledgerAccounts.find(coa => coa.code === oneRow.ledgerAccountInfo.code)

    const rowData = {
      code: oneRow.ledgerAccountInfo.code,
      budget: oneRow,
      ledgerAccount
    }

    if (ledgerAccount) {
      const financialStatementValue = analysedFinancials?.byAccountingChartOfAccountId.get(ledgerAccount.id)
      if (financialStatementValue) {
        rowData.financialStatementValue = financialStatementValue
      }
    }

    return rowData
  })

  console.log('BudgetGrid matchBudgetToLedgerAccounts matchedData', matchedData)
  return matchedData
}

function updateGrid (instance, gridData) {
  console.log('BudgetGrid updateGrid', gridData)
  instance.gridApi.setGridOption('rowData', gridData.rows)
}

function initGrid (instance, gridData) {
  const gridOptions = {
    theme: themeQuartz,
    rowData: gridData.rows,
    columnDefs: makeColumnDefs(instance),

    pinnedTopRowData: [{
      code: 'Total',
      row: 'Total'
    }],
    getRowClass: function (params) {
      console.log('getRowClass', params)
      if (params.data.row === 'Total') {
        console.log('total-row', params.data)
        return 'total-row'
      }
    },

    onCellClicked: function (cellParams) {
      console.log('cellParams', cellParams)
      console.log('instance', instance)
    }
  }
  console.log('gridOptions', gridOptions)

  const gridContainerElement = instance.mountedOn.querySelector('#grid-container')
  gridContainerElement.innerHTML = ''
  console.log('gridContainerElement', gridContainerElement)
  instance.gridApi = createGrid(gridContainerElement, gridOptions)

  addListeners(instance)
}

function makeCellClass (cellParams) {
  const classes = []
  if (!cellParams.value) classes.push('zero')

  if (Number.isFinite(cellParams.value)) classes.push('number')

  return classes
}

function makeColumnDefs (instance) {
  const columnDefs = [
    {
      field: 'code',
      headerName: 'Code',
      pinned: 'left',
      width: 80
      // type: 'stringColumn'
    },
    {
      // field: 'budget.ledgerAccountInfo.name',
      headerName: 'Account',
      pinned: 'left',
      valueGetter: function (cellParams) {
        if (cellParams.data.row === 'Total') {
          const budgetLines = instance.data?.budget?.parsedData?.filter(oneRow => oneRow.totalAmount)
          return budgetLines.length + ' Budget lines'
        } else {
          return cellParams.data.ledgerAccount?.name
        }
      }
      // type: 'stringColumn'
    },
    {
      headerName: 'Budget',
      type: 'numericColumn',
      valueGetter: function (cellParams) {
        if (cellParams.data.row === 'Total') {
          const budgetLines = instance.data?.budgetAccountsWithLedgerAccounts?.filter(oneRow => oneRow.budget?.totalAmount)
          const totalBudget = budgetLines?.reduce((acc, oneRow) => acc + oneRow.budget?.totalAmount, 0)
          return totalBudget
        } else {
          return cellParams.data.budget?.totalAmount
        }
      },
      valueFormatter: function (cellParams) {
        if (!cellParams.value) return null
        return formatNumber(cellParams.value, instance.data.decimals)
      },
      cellClass: makeCellClass,
      width: 120
    },
    {
      headerName: 'Account in Xero',
      valueGetter: function (cellParams) {
        if (cellParams.data.row === 'Total') {
          const budgetLines = instance.data?.budgetAccountsWithLedgerAccounts?.filter(oneRow => oneRow.budget?.totalAmount && oneRow.ledgerAccount)

          return budgetLines?.length + ' are in Xero'
        } else {
          return cellParams.data.ledgerAccount?.name
        }
      },
      cellRenderer: function (cellParams) {
        if (!cellParams.value) {
          return '<button class="button is-primary is-small is-flex" data-action="create">Create in Xero</button>'
        }
        return cellParams.value
      }
    }
  ]

  // Monthly
  instance.data.financialStatement?.analysedFinancials?.month.forEach(month => {
    columnDefs.push({
      headerName: month,
      type: 'numericColumn',
      valueGetter: function (cellParams) {
        if (cellParams.data.row === 'Total') {
          const budgetLines = instance.data?.budgetAccountsWithLedgerAccounts?.filter(oneRow => oneRow.financialStatementValue)
          const totalActuals = budgetLines?.reduce((acc, oneRow) => acc + (oneRow.financialStatementValue?.byMonth?.get(month)?.totalAmount || 0), 0)

          return totalActuals
        } else {
          return cellParams.data.financialStatementValue?.byMonth.get(month)?.totalAmount
        }
      },
      width: 120,
      valueFormatter: function (cellParams) {
        if (!cellParams.value) return null
        return formatNumber(cellParams.value, instance.data.decimals)
      },
      cellClass: makeCellClass
    })
  })

  // Totals
  columnDefs.push({
    headerName: 'Total Actuals',
    valueGetter: function (cellParams) {
      if (cellParams.data.row === 'Total') {
        const actualsLines = instance.data?.budgetAccountsWithLedgerAccounts?.filter(oneRow => oneRow.financialStatementValue)
        const totalActuals = actualsLines?.reduce((acc, oneRow) => acc + oneRow.financialStatementValue?.totalAmount || 0, 0)
        return totalActuals
      } else {
        return cellParams.data.financialStatementValue?.totalAmount
      }
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null
      return formatNumber(cellParams.value, instance.data.decimals)
    },
    width: 120,
    cellClass: makeCellClass,
    pinned: 'right',
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'Remaining Budget',
    valueGetter: function (cellParams) {
      if (cellParams.data.row === 'Total') {
        const budgetLines = instance.data?.budgetAccountsWithLedgerAccounts?.filter(oneRow => oneRow.budget?.totalAmount)
        const totalBudget = budgetLines?.reduce((acc, oneRow) => acc + oneRow.budget?.totalAmount, 0)

        const actualsLines = instance.data?.budgetAccountsWithLedgerAccounts?.filter(oneRow => oneRow.financialStatementValue)
        const totalActuals = actualsLines?.reduce((acc, oneRow) => acc + oneRow.financialStatementValue?.totalAmount || 0, 0)

        return totalBudget - totalActuals
      } else {
        return (cellParams.data.budget?.totalAmount || 0) - (cellParams.data.financialStatementValue?.totalAmount || 0)
      }
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null
      return formatNumber(cellParams.value, instance.data.decimals)
    },
    cellClass: makeCellClass,
    width: 120,
    pinned: 'right',
    type: 'numericColumn'
  })

  return columnDefs
}

function addListeners (instance) {
  instance.gridApi.addEventListener('cellClicked', async function (cellParams) {
    console.log('listener cellParams', cellParams)
    if (cellParams.data.ledgerAccount?.name) return

    const buttonElement = cellParams.event.target.closest('button')
    if (!buttonElement) return

    const action = buttonElement.getAttribute('data-action')
    console.log('action', action)
    if (action === 'create') {
      // createAccount(cellParams.data.ledgerAccount.id)
      buttonElement.classList.add('is-loading')

      console.log('instance.accountingOrganisationId', instance.accountingOrganisationId)
      console.log('cellParams.ledgerAccountInfo.code', cellParams.data.budgetData?.ledgerAccountInfo?.code)
      console.log('cellParams.ledgerAccountInfo.name', cellParams.data.budgetData?.ledgerAccountInfo?.name)

      await callApi('/api/xero-api/account', null, {
        body: {
          accountingOrganisationId: instance.accountingOrganisationId,
          code: cellParams.data.budgetData?.ledgerAccountInfo?.code,
          name: cellParams.data.budgetData?.ledgerAccountInfo?.name
        },
        method: 'POST'
      }
      )

      buttonElement.classList.remove('is-loading')
    }
  })
}
